import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";
import cn from "classnames";
import Button from "@ebsco-ui/button";

export enum ScrollControlTypes {
  start = "start",
  end = "end",
}

interface ScrollControlProps {
  isEnabled: boolean;
  isRTL?: boolean;
  title: string;
  type: ScrollControlTypes;
  onClick: (type: ScrollControlTypes) => void;
  className: string;
}

const ICONS = {
  ltr: {
    start: faChevronLeft,
    end: faChevronRight,
  },
  rtl: {
    start: faChevronRight,
    end: faChevronLeft,
  },
};

const ScrollControl = ({
  isEnabled,
  isRTL,
  title,
  type,
  onClick,
  className,
}: ScrollControlProps) => {
  const icons = ICONS[isRTL ? "rtl" : "ltr"];
  const onControlClick = onClick.bind(null, type);

  return (
    <Button
      disabled={!isEnabled}
      className={cn(className, `${className}--${type}`)}
      onClick={onControlClick}
      aria-hidden={true}
      tabIndex={-1}
      styleType="flat-icon"
      type="button"
      title={title}
      data-auto={`tabs-scroll-${type}`}
    >
      <FontAwesomeIcon icon={icons[type]} />
    </Button>
  );
};

ScrollControl.defaultProps = {
  isRTL: false,
};

export default ScrollControl;
